// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.usersTableWrapper__UPOyT {
  width: 100%;
  max-width: 100%;
  max-height: calc(100vh - 312px);
  overflow: auto;
  box-shadow: var(--basic-box-shadow);
}
.usersTableWrapper__UPOyT::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.usersTableWrapper__UPOyT::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.usersTableWrapper__UPOyT::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.usersTableWrapper__UPOyT::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.usersTable__owsDR {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  position: relative;
}
.usersTable__owsDR th {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  text-transform: uppercase;
  color: var(--tables-title-text);
  padding: 15px 25px;
  border-bottom: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
  text-align: left;
  text-wrap: nowrap;
  position: sticky;
  top: 0;
  z-index: 1;
}
@media (max-width: 960px) {
  .usersTable__owsDR th {
    padding: 10px 10px;
  }
}
.usersTable__owsDR td {
  padding: 15px 25px;
  color: var(--tables-primary-row-text-main);
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-default);
  transition: all 150ms ease-in-out;
  font-size: 14px;
  line-height: 16px;
}
@media (max-width: 960px) {
  .usersTable__owsDR td {
    padding: 8px 10px;
  }
}

.usersBodyRow__VS8sx:hover td {
  background: var(--tables-primary-row-surface-hover);
  border-bottom: 1px solid var(--tables-primary-row-stroke);
}

.ellipsisTextOneLine__VpmnX {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  line-clamp: 1;
}

.usersTableHeadCellContainer__SUdNe {
  display: flex;
  align-items: center;
  text-wrap: nowrap;
}
@media (max-width: 1330px) {
  .usersTableHeadCellContainer__SUdNe {
    text-wrap: wrap;
  }
}

@media (max-width: 1330px) {
  .flexHeader__n48Yv {
    flex: 0;
  }
}

.usersTableSortIcon__RqORY {
  margin-left: 5px;
  cursor: pointer;
  outline: none;
  min-width: 6px;
}
.usersTableSortIcon__RqORY path {
  fill: var(--tables-title-icon);
}

.activeSort__CxIGu path {
  fill: var(--tables-primary-row-icon);
}

.nameColumn__igo5H {
  min-width: 70px;
}

.emailHidden__EMqJH {
  color: var(--tables-primary-row-text-additional);
  font-size: 12px;
  line-height: 18px;
}
@media (min-width: 1281px) {
  .emailHidden__EMqJH {
    display: none;
  }
}
@media (max-width: 1000px) {
  .emailHidden__EMqJH {
    max-width: 160px;
  }
}

.usernameColumn__Y1dDi {
  max-width: 180px;
}
@media (max-width: 1400px) {
  .usernameColumn__Y1dDi {
    max-width: 160px;
  }
}
@media (max-width: 1280px) {
  .usernameColumn__Y1dDi {
    display: none;
  }
}

@media (max-width: 1400px) {
  .emailColumn__NnGOy {
    max-width: 185px;
  }
}
@media (max-width: 1280px) {
  .emailColumn__NnGOy {
    display: none;
  }
}

.userStatusColumn__Gpr1g {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  text-align: end !important;
}

.userStatusWrapper__o6D_A {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  column-gap: 3px;
}

.blockIcon__gL2Kt path {
  stroke: var(--tables-primary-row-icon);
}

.lastSeen__VXhfw {
  color: var(--tables-primary-row-text-additional);
  font-size: 12px;
  line-height: 18px;
  text-align: right;
}

.actionsColumn__mVDxO {
  min-width: 30px;
  width: 30px;
}
.actionsColumn__mVDxO svg circle {
  fill: var(--tables-primary-row-icon);
}

.actionsIconContainer__q0EKo {
  position: relative;
  width: 25px;
  height: 25px;
  padding: 3px;
  -webkit-user-select: none;
          user-select: none;
  text-align: center;
  border-radius: 50%;
  cursor: pointer;
  outline: none;
}
.actionsIconContainer__q0EKo:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.usersFooter__YXDV1 {
  margin-top: 25px;
  font-size: 10px;
  text-transform: uppercase;
  color: var(--inputs-default-text);
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 25px;
}

.usersTotalLength__w1aPj {
  color: var(--inputs-default-text);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
}

.skeletonText__rkWv1 {
  height: 12px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/Users/components/TableUsers/style.module.scss"],"names":[],"mappings":"AA4EA;EACE,WAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,mCAAA;AA3EF;AAoBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAlBJ;AAqBE;EACE,+BAAA;EACA,kBAAA;AAnBJ;AAsBE;EACE,8BAAA;EACA,kBAAA;AApBJ;AAuBE;EACE,gBAAA;EACA,kBAAA;AArBJ;;AA+DA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;AA5DF;AA8DE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,+BAAA;EACA,kBAAA;EACA,mDAAA;EACA,uCAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AA5DJ;AA8DI;EAfF;IAgBI,kBAAA;EA3DJ;AACF;AA8DE;EACE,kBAAA;EACA,0CAAA;EACA,yDAAA;EACA,qDAAA;EACA,iCAAA;EACA,eAAA;EACA,iBAAA;AA5DJ;AA8DI;EATF;IAUI,iBAAA;EA3DJ;AACF;;AAgEE;EACE,mDAAA;EACA,yDAAA;AA7DJ;;AAiEA;EArFE,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EAkFA,qBAAA;EACA,aAAA;AAzDF;;AA4DA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AAzDF;AA2DE;EALF;IAMI,eAAA;EAxDF;AACF;;AA4DE;EADF;IAEI,OAAA;EAxDF;AACF;;AA2DA;EACE,gBAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;AAxDF;AA0DE;EACE,8BAAA;AAxDJ;;AA6DE;EACE,oCAAA;AA1DJ;;AA8DA;EACE,eAAA;AA3DF;;AA8DA;EACE,gDAAA;EACA,eAAA;EACA,iBAAA;AA3DF;AA6DE;EALF;IAMI,aAAA;EA1DF;AACF;AA4DE;EATF;IAUI,gBAAA;EAzDF;AACF;;AA4DA;EACE,gBAAA;AAzDF;AA2DE;EAHF;IAII,gBAAA;EAxDF;AACF;AA0DE;EAPF;IAQI,aAAA;EAvDF;AACF;;AA2DE;EADF;IAEI,gBAAA;EAvDF;AACF;AAyDE;EALF;IAMI,aAAA;EAtDF;AACF;;AAyDA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,0BAAA;AAtDF;;AAyDA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AAtDF;;AA0DE;EACE,sCAAA;AAvDJ;;AA2DA;EACE,gDAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AAxDF;;AA2DA;EACE,eAAA;EACA,WAAA;AAxDF;AA2DI;EACE,oCAAA;AAzDN;;AA8DA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;AA3DF;AA6DE;EACE,qCAAA;AA3DJ;;AA+DA;EACE,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,iCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AA5DF;;AA+DA;EACE,iCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AA5DF;;AA+DA;EACE,YAAA;AA5DF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n@import 'src/assets/variables.scss';\n\n.usersTableWrapper {\n  width: 100%;\n  max-width: 100%;\n  max-height: calc(100vh - 312px);\n  overflow: auto;\n  box-shadow: var(--basic-box-shadow);\n\n  @include scrollBar;\n}\n\n.usersTable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  position: relative;\n\n  th {\n    font-size: 10px;\n    font-weight: 400;\n    line-height: 12px;\n    text-transform: uppercase;\n    color: var(--tables-title-text);\n    padding: 15px 25px;\n    border-bottom: 1px solid var(--tables-title-stroke);\n    background: var(--tables-title-surface);\n    text-align: left;\n    text-wrap: nowrap;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n\n    @media (max-width: 960px) {\n      padding: 10px 10px;\n    }\n  }\n\n  td {\n    padding: 15px 25px;\n    color: var(--tables-primary-row-text-main);\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    background: var(--tables-primary-row-surface-default);\n    transition: all 150ms ease-in-out;\n    font-size: 14px;\n    line-height: 16px;\n\n    @media (max-width: 960px) {\n      padding: 8px 10px;\n    }\n  }\n}\n\n.usersBodyRow {\n  &:hover td {\n    background: var(--tables-primary-row-surface-hover);\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n  }\n}\n\n.ellipsisTextOneLine {\n  @include ellipsis-text;\n  -webkit-line-clamp: 1;\n  line-clamp: 1;\n}\n\n.usersTableHeadCellContainer {\n  display: flex;\n  align-items: center;\n  text-wrap: nowrap;\n\n  @media (max-width: 1330px) {\n    text-wrap: wrap;\n  }\n}\n\n.flexHeader {\n  @media (max-width: 1330px) {\n    flex: 0;\n  }\n}\n\n.usersTableSortIcon {\n  margin-left: 5px;\n  cursor: pointer;\n  outline: none;\n  min-width: 6px;\n\n  path {\n    fill: var(--tables-title-icon);\n  }\n}\n\n.activeSort {\n  path {\n    fill: var(--tables-primary-row-icon);\n  }\n}\n\n.nameColumn {\n  min-width: 70px;\n}\n\n.emailHidden {\n  color: var(--tables-primary-row-text-additional);\n  font-size: 12px;\n  line-height: 18px;\n\n  @media (min-width: 1281px) {\n    display: none;\n  }\n\n  @media (max-width: 1000px) {\n    max-width: 160px;\n  }\n}\n\n.usernameColumn {\n  max-width: 180px;\n\n  @media (max-width: 1400px) {\n    max-width: 160px;\n  }\n\n  @media (max-width: 1280px) {\n    display: none;\n  }\n}\n\n.emailColumn {\n  @media (max-width: 1400px) {\n    max-width: 185px;\n  }\n\n  @media (max-width: 1280px) {\n    display: none;\n  }\n}\n\n.userStatusColumn {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  text-align: end !important;\n}\n\n.userStatusWrapper {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  column-gap: 3px;\n}\n\n.blockIcon {\n  path {\n    stroke: var(--tables-primary-row-icon);\n  }\n}\n\n.lastSeen {\n  color: var(--tables-primary-row-text-additional);\n  font-size: 12px;\n  line-height: 18px;\n  text-align: right;\n}\n\n.actionsColumn {\n  min-width: 30px;\n  width: 30px;\n\n  svg {\n    circle {\n      fill: var(--tables-primary-row-icon);\n    }\n  }\n}\n\n.actionsIconContainer {\n  position: relative;\n  width: 25px;\n  height: 25px;\n  padding: 3px;\n  user-select: none;\n  text-align: center;\n  border-radius: 50%;\n  cursor: pointer;\n  outline: none;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.04);\n  }\n}\n\n.usersFooter {\n  margin-top: 25px;\n  font-size: 10px;\n  text-transform: uppercase;\n  color: var(--inputs-default-text);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 25px;\n}\n\n.usersTotalLength {\n  color: var(--inputs-default-text);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n}\n\n.skeletonText {\n  height: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"usersTableWrapper": `usersTableWrapper__UPOyT`,
	"usersTable": `usersTable__owsDR`,
	"usersBodyRow": `usersBodyRow__VS8sx`,
	"ellipsisTextOneLine": `ellipsisTextOneLine__VpmnX`,
	"usersTableHeadCellContainer": `usersTableHeadCellContainer__SUdNe`,
	"flexHeader": `flexHeader__n48Yv`,
	"usersTableSortIcon": `usersTableSortIcon__RqORY`,
	"activeSort": `activeSort__CxIGu`,
	"nameColumn": `nameColumn__igo5H`,
	"emailHidden": `emailHidden__EMqJH`,
	"usernameColumn": `usernameColumn__Y1dDi`,
	"emailColumn": `emailColumn__NnGOy`,
	"userStatusColumn": `userStatusColumn__Gpr1g`,
	"userStatusWrapper": `userStatusWrapper__o6D_A`,
	"blockIcon": `blockIcon__gL2Kt`,
	"lastSeen": `lastSeen__VXhfw`,
	"actionsColumn": `actionsColumn__mVDxO`,
	"actionsIconContainer": `actionsIconContainer__q0EKo`,
	"usersFooter": `usersFooter__YXDV1`,
	"usersTotalLength": `usersTotalLength__w1aPj`,
	"skeletonText": `skeletonText__rkWv1`
};
module.exports = ___CSS_LOADER_EXPORT___;
